<div class="flex flex-col lg:flex-row gap-4">
  <!-- Signup Form Card -->
  <div class="signup-card w-full mb-3">
    <div>
      <h2 class="text-2xl lg:text-3xl font-semibold text-gray-800 headerStyling">
        Let's sync with your team
      </h2>
      <p class="business-sub-header">
        Help us to get basic details of your team and we will send them invites to help them setup
        with wiser for your business.
      </p>
    </div>

    <form [formGroup]="TeamDetailsForm" class="flex flex-col space-y-4 min-h-[500px] mt-5">
      <h2 class="text-[19px] font-bold text-[#00B87A] m-0">
        Create your team by assigning them roles
      </h2>

      <!-- Container -->
      <div class="flex items-center justify-between gap-4 py-3 bg-white">
        <!-- Left: avatar + name -->
        <div class="flex items-center gap-1">
          <!-- Avatar -->
          <img src="user-icon.svg" alt="user name" class="w-11 h-11 rounded-full object-cover bg-[#D4D9E0] p-2" />

          <!-- Name (blue highlighted pill) -->
          <div class="inline-flex items-center">
            <span class="px-2 py-0.5 text-[#00165A] text-[18px] font-bold"> {{ userName }} </span>
          </div>
        </div>

        <!-- Right: role badge -->
        <div>
          <span class="inline-flex items-center px-4 py-1 text-[18px] font-bold rounded-[10px] border border-slate-200">
            Administrator
          </span>
        </div>
      </div>

      <!-- Dynamic rows -->
      <div formArrayName="teamMembers" class="flex flex-col gap-4">
        @for (member of teamMembers.controls; track $index; let i = $index) {
        <div [formGroupName]="i" class="flex gap-4">
          <app-input formControlName="name" label="Name" [submitted]="submitted"
            labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
            inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
            placeholder="Enter your employee name" class="w-3/5"></app-input>

          <app-dropdown label="Role" formControlName="role" [options]="employeeRole" optionLabel="name" optionValue="id"
            [submitted]="submitted" placeholder="Select a employee role"
            labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
            inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
            showClear="true" class="w-2/5"></app-dropdown>
        </div>
        }
      </div>

      <!-- Add more button -->
      <app-button label="Add more" type="button" size="large" (clicked)="addMoreTeamMates()"
        customClass="flex items-center text-white border-[2px] border-[#9AA2AE] rounded-full px-4 py-1 text-sm font-medium custom-gray"></app-button>

      <!-- Submit button -->
      <div class="mt-auto pt-4 w-full">
        <app-button label="Finish setup" type="button" (click)="onSubmit()"
          customClass="wideButton w-full custom-dark-blue" size="large"></app-button>
      </div>
    </form>
  </div>
</div>